import { render } from "./CaptureStamp.vue?vue&type=template&id=798da832&scoped=true"
import script from "./CaptureStamp.vue?vue&type=script&lang=js"
export * from "./CaptureStamp.vue?vue&type=script&lang=js"

import "./CaptureStamp.vue?vue&type=style&index=0&id=798da832&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798da832"]])

export default __exports__